// Per-page SEO metadata (from client-provided metadati_mypushapp.docx).
// Canonical paths use the site's REAL routes.

export const SEO = {
  home: {
    path: "/",
    title: "Centro Guida PushApp | Tutorial e supporto clienti",
    description:
      "Scopri come usare PushApp: guida pratica per gestire news, eventi, promozioni e notifiche push della tua web app.",
    ogTitle: "Centro Guida PushApp | Impara a usare la tua app",
    ogDescription:
      "Una guida semplice per usare PushApp, gestire contenuti e comunicare meglio con i clienti tramite notifiche push.",
  },
  guide: {
    path: "/guide",
    title: "Guide PushApp | Tutorial per usare la tua web app",
    description:
      "Consulta le guide PushApp e scopri come gestire contenuti, promozioni, eventi e notifiche della tua web app.",
    ogTitle: "Guide PushApp | Tutorial semplici e pratici",
    ogDescription:
      "Istruzioni chiare per imparare a usare PushApp e sfruttare al meglio le principali funzioni della tua web app.",
  },
  strategie: {
    path: "/strategie",
    title: "Strategie PushApp | Idee per coinvolgere i clienti",
    description:
      "Scopri strategie e consigli pratici per usare PushApp, aumentare il coinvolgimento dei clienti e valorizzare promozioni ed eventi.",
    ogTitle: "Strategie PushApp | Comunica meglio con i tuoi clienti",
    ogDescription:
      "Consigli pratici per pianificare contenuti, promozioni, eventi e notifiche efficaci con PushApp.",
  },
  notifiche: {
    path: "/notifiche",
    title: "Notifiche Push Pronte | Testi e modelli per clienti",
    description:
      "Trova esempi di notifiche push già pronte da usare con PushApp per promozioni, eventi, novità e comunicazioni ai clienti.",
    ogTitle: "Notifiche push pronte | Esempi da copiare",
    ogDescription:
      "Modelli di notifiche push per promozioni, eventi, novità e comunicazioni utili da inviare ai tuoi clienti con PushApp.",
  },
  faq: {
    path: "/faq",
    title: "FAQ PushApp | Domande frequenti e risposte utili",
    description:
      "Leggi le FAQ PushApp e trova risposte rapide su utilizzo della web app, gestione contenuti, promozioni e notifiche push.",
    ogTitle: "FAQ PushApp | Risposte alle domande frequenti",
    ogDescription:
      "Trova risposte semplici e immediate alle domande più comuni sull'utilizzo di PushApp e delle notifiche push.",
  },
  checklist: {
    path: "/checklist",
    title: "Errori da evitare & Checklist mensile | PushApp",
    description:
      "Gli errori più comuni da evitare con le notifiche push e la checklist mensile per usare PushApp con costanza ed efficacia.",
    ogTitle: "Errori da evitare & Checklist | PushApp",
    ogDescription:
      "Cosa non fare con le notifiche push e la routine mensile per ottenere risultati costanti con PushApp.",
  },
  assistenza: {
    path: "/assistenza",
    title: "Assistenza PushApp | Contatti e supporto",
    description:
      "Hai bisogno di aiuto con PushApp? Chiedi ad Asia, l'assistente AI, oppure contatta il team via email, telefono o WhatsApp.",
    ogTitle: "Assistenza PushApp | Siamo qui per aiutarti",
    ogDescription:
      "Supporto per la tua web app PushApp: assistente AI, email, telefono e WhatsApp.",
  },
};
